import { useDispatch, useSelector } from 'react-redux'
import { Callback, CreateCustomerInput } from 'lib/types'
import { getAccountRequiresConfirmation } from 'lib/core/data/common/storeConfig/selectors'
import { createCustomer } from 'lib/core/data/customer/createCustomer'
import { getSlice, getError } from 'lib/core/data/customer/createCustomer/selectors'
import { Ga4Events } from '../../../gtm/index'

export interface CreateAccountHookOptions {
  callback?: Callback
}

export const useCreateCustomer = () => {
  const dispatch = useDispatch()
  const slice = useSelector(getSlice)
  const errorCode = useSelector(getError)
  const accountRequiresConfirmation = Boolean(useSelector(getAccountRequiresConfirmation))

  return {
    isFetching: slice.isFetching,
    isFailure: slice.isFailure,
    requiresConfirmation: accountRequiresConfirmation,
    errorCode,

    createCustomer: (input: CreateCustomerInput, options: CreateAccountHookOptions) => {
      dispatch(createCustomer(input, {
        onSuccess: options?.callback?.onSuccess,
        onFailure: options?.callback?.onFailure
      }))
      Ga4Events.signUp({ method: 'email' })
    }
  }
}
